import { render } from "./SpaceMenu.vue?vue&type=template&id=2396b11f&scoped=true"
import script from "./SpaceMenu.vue?vue&type=script&lang=js"
export * from "./SpaceMenu.vue?vue&type=script&lang=js"

import "./SpaceMenu.vue?vue&type=style&index=0&id=2396b11f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2396b11f"]])

export default __exports__